
import PropTypes from 'prop-types';
import LoadingBox from '../../Component/LoadingBox';
import MessageBox from '../../Component/MessageBox';
import { useDispatch, useSelector } from 'react-redux';
import { payOrder } from '../../redux/actions/orderAction';

export default function OrderSummmary({
  order,
  itemsPrice,
  shippingPrice,
  taxPrice,
  totalPrice,
  isPaid,
  sdkReady,
}) {
  const dispatch = useDispatch();
  const orderPay = useSelector(state => state.orderPay);
  const { loading: loadingPay, error: errorPay } = orderPay;
  const successPayHandler = paymentResult => {
    dispatch(payOrder(order, paymentResult));
  };

  return (
    <div className="order order-body">
      <ul>
        <li>
          <h2>
            <strong>Order Summary</strong>
          </h2>
        </li>
        <li>
          <div className="products">
            <div>Items</div>
            <div>${(itemsPrice || 0).toFixed(2)}</div>
          </div>
        </li>
        <li>
          <div className="products">
            <div>Shipping </div>
            <div>${(shippingPrice || 0).toFixed(2)}</div>
          </div>
        </li>
        <li>
          <div className="products">
            <div>Tax</div>
            <div>${(taxPrice || 0).toFixed(2)}</div>
          </div>
        </li>
        <li>
          <div className="products">
            <div>
              <strong>Order Total</strong>
            </div>
            <div>
              <strong>${(totalPrice || 0).toFixed(2)}</strong>
            </div>
          </div>
        </li>

        {!isPaid && (
          <li>
            <div className="products">
              {!sdkReady ? (
                <LoadingBox></LoadingBox>
              ) : (
                // Aquí iría el componente de pago, por ejemplo PayPalButton
                <div>Payment Component Here</div>
              )}
            </div>
          </li>
        )}
      </ul>
    </div>
  );
}

OrderSummmary.propTypes = {
  itemsPrice: PropTypes.number.isRequired,
  shippingPrice: PropTypes.number.isRequired,
  taxPrice: PropTypes.number.isRequired,
  totalPrice: PropTypes.number.isRequired,
  isPaid: PropTypes.bool.isRequired,
  sdkReady: PropTypes.bool.isRequired,
  PayPalButton: PropTypes.elementType.isRequired,
};
